<template>
    <div>
        <b-modal
                id="uae-pass-popup"
                ref="modal"
                :title="title"
                size="md"
                hide-footer
                modal-class="hide-footer"
                no-close-on-backdrop
                no-close-on-esc
                hide-header-close=true
        >
            <div>
                <p class="font-bold"
                        style="padding-top:10px;padding-left:25px; font-size: 16px; color: #424141"
                >
                    Do you have an online account with Idenfo Direct?
                </p>
                <ul>
                    <li>Your UAE PASS account will be linked to existing Idenfo account</li>
                    <li>Your Idenfo account will be established based on the UAE PASS account</li>
                </ul>

                <em style="font-size: 12px;padding-left: 25px;">Note: This is one time process, your future login's through UAE PASS will be seamless</em>
            </div>
            <div class="col-md-12 action-buttons">
                <b-button
                        type="button"
                        variant="primary"
                        class="primary-add-btn"
                        @click="onConfirmPopup"
                        :disabled = "loading"
                >
                    <span class="btn-text">{{ confirmText }}</span>
                    <span class="loader"></span>
                </b-button>

                <b-button
                        type="button"
                        variant="link"
                        @click="onCancelPopup"
                        :disabled = "loading"
                >
                    <span class="btn-text">{{ cancelText }}</span>
                    <span class="loader"></span>
                </b-button>
            </div>

        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    // import Multiselect from 'vue-multiselect'
    // import _ from "lodash";
    // import resource from "@/api/resource";

    import request from '@/utils/request'

    // const roleApi = new resource("access-control/roles");
    // const dataSegmentApi = new resource("access-control/data-segments");

    export default {
        components: {
            // Multiselect,
        },

        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
        props: {
            title:{
                type:String,
                default: 'Confirmation',
            },
            description:{
                type:String,
                default: 'Are you sure, You want to Resend Email?',
            },
            confirmText: {
                type: String,
                default: 'Yes',
            },
            cancelText: {
                type: String,
                default: 'Cancel',
            },
            onConfirm:{
                type:Function,
                default: ()=>{}
            },
            onCancel:{
                type:Function,
                default: ()=>{}
            },
        }, // End of Component > props
        /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */

        data() {
            return {
            };
        },
        /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
        computed: {
            ...mapGetters(["loading", "selectedItem","dataSegmentId"]),

        }, // End of Component > computed
        /*
        |--------------------------------------------------------------------------
        | Component > watch
        |--------------------------------------------------------------------------
        */
        watch: {
        }, // End of Component > watch

        mounted() {

            console.log(this.selectedItem)
        },
        methods: {
            async onConfirmPopup(){
                this.$store.commit('setSuccess', 'You have successfully authenticate with UAE PASS. (Note: This is a one time process)')
                await this.onConfirm()
                this.$bvModal.hide('uae-pass-popup')
            },
            async onCancelPopup() {
                await this.onCancel();
                this.$bvModal.hide('uae-pass-popup')
            },
        }
    };
</script>
